
import commonFetch from './commonFetch';

import type { StatusResponse } from '../types/statusResponse';

export const sendMessageConfigurationTestEmail = (
  messageConfigId: string,
  testMessageType: string,
  email: string,
): Promise<StatusResponse> => {
  const requestBody = {
    testMessageType,
    email,
  };
  return commonFetch(
    `/api/messageConfigs/${messageConfigId}/email/test`,
    requestBody,
    'POST',
  ).then(response =>
    response.json().then(responseBody => {
      if (!response.ok) {
        const error = {
          errorBody: responseBody,
          statusCode: response.status,
        };
        throw error;
      }
      return responseBody;
    }),
  );
};
